 import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';;
import { SessionService } from './session.service';
import { AccessDeniedService } from '../../shared/services/access-denied.service';

@Injectable()
export class IsAuthorizedService implements CanActivate {

  constructor(private router: Router, private session: SessionService, private accessDeniedService: AccessDeniedService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.session.getUser() && this.session.getUser()?.siret) {
      return true;
    }
    this.accessDeniedService.unauthorized();

    return false;
  }
}
